import { Outlet, useLocation, useNavigate } from "react-router";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { InvoicesPage, InvoicesPageSidebar } from "./_components/invoices-page";
import { MainPageContent } from "../_components/main-page";

export function InvoicesRoute() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isReleased = useBooleanFlagValue("gsm.invoices", true);
  const canAccess = useFeatureAuth("gsm.invoices");
  if (!canAccess || !isReleased) {
    return (
      <MainPageContent>
        <Alert403 />
      </MainPageContent>
    );
  }

  return (
    <InvoicesPage>
      <InvoicesPageSidebar onNavigate={navigate} activePath={pathname} />
      <Outlet />
    </InvoicesPage>
  );
}
